<template>
  <Modal :visible="visible" @close="$emit('cancel')">
    <template #header>
      <p class="modalTitle">Confirm Cancellation</p>
    </template>
    <template #body>
      <p>{{ message }}</p>
    </template>
    <template #footer>
      <div class="btnWrap">
        <button @click="$emit('cancel')" class="submit-button cancelBtn">Close</button>
        <button @click="$emit('confirm')" class="submit-button">Cancel Reservation</button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import Modal from "@/components/Modal.vue";

const props = defineProps({
  message: {
    type: String,
    required: true,
  },
  visible: { type: Boolean, required: true },
});

const emit = defineEmits(["confirm", "cancel"]);
</script>

<style>
    .modal-header, .modal-footer{
        padding: 0!important;
        border-bottom: none !important;
    }
    .modal-container{
        padding: 2rem;
    }
</style>
<style scoped>
    .error {
        color: red;
        margin-top: 8px;
    }
    .btnWrap {
        display: flex;
        justify-content: center;
        margin-top: 1rem;
    }

    .modalTitle{
        font-size: 20px;
        color: var(--blue);
        font-weight: 600;
        text-align: center;
        margin:0;
        & span{
            font-size: 0.9em;
        }
    }
    .submit-button {
        background: var(--gradCan);
        width: 100%;
        max-width: 300px;
        padding: 1rem;
        border: none;
        color: white;
        border-radius: 10px;
        margin: 0;
        display: block;

        &.cancelBtn{
            background: none;
            border: 1px solid var(--blue);
            color: var(--blue);
            max-width: 150px;
            margin-right: 1rem;
        }

        .submit-button:disabled {
            background: #cccccc;
            cursor: inherit;
        }
    }
</style>